import api from "./api";

class Countries {
  get(){
    return api.get(`v1/api/countries`);
  }
}

export default new Countries();
